import { createConfig, http } from 'wagmi'
import { mainnet, sepolia } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '7290beb9cb769e4bf2b67f9efc20e5ad'

export const config = createConfig({
  chains: [mainnet, sepolia],
  connectors: [
    injected({ 
      shimDisconnect: true,
      target: 'metaMask'
    }),
    walletConnect({
      projectId,
      showQrModal: true,
      qrModalOptions: {
        themeMode: 'light',
        themeVariables: {
          '--wcm-z-index': '9999'
        }
      },
      metadata: {
        name: 'Public Respect',
        description: 'Decentralized reputation platform',
        url: typeof window !== 'undefined' ? window.location.origin : 'https://publicrespect.app',
        icons: [typeof window !== 'undefined' ? `${window.location.origin}/pr-logo.png` : 'https://publicrespect.app/pr-logo.png']
      }
    }),
  ],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
  },
})